/**
 * Adopt a CSS string onto a document or shadow root via a constructable
 * stylesheet (`adoptedStyleSheets`).
 *
 * WHY: constructable stylesheets are programmatic CSSOM and therefore NOT governed
 * by the prod CSP `style-src` — so strict CSP needs no `'unsafe-inline'`. Where
 * they are unavailable (e.g. jsdom, which lacks `replaceSync`) we fall back to a
 * `<style>` element; that path is test-only and never hits the production CSP.
 */
export function adoptStyles(target: DocumentOrShadowRoot & { appendChild?: unknown }, css: string): void {
  try {
    const sheet = new CSSStyleSheet();
    if (typeof sheet.replaceSync !== 'function') throw new Error('no replaceSync');
    sheet.replaceSync(css);
    target.adoptedStyleSheets = [...target.adoptedStyleSheets, sheet];
  } catch {
    const style = document.createElement('style');
    style.textContent = css;
    const host = 'head' in target ? (target as Document).head : (target as unknown as ShadowRoot);
    host.appendChild(style);
  }
}
